import React from 'react';
import Ceremony2023 from 'views/Ceremony2023';

const ChildrensDayPage = () => {
  return <Ceremony2023 />;
};

export default ChildrensDayPage;
